import { useMemo } from "react";
import { useServices, useWorkspaces } from "@/hooks/useApi";
import { usePipelineScripts } from "@/hooks/usePipelineScripts";
import { workspaceForJob } from "@/pages/workspaceHelpers";
import type { Connector } from "@/types/api";

// What the pipeline shows of its definition beyond the job record: the
// workspace it was deployed from (created/modified stamps) and the
// transform scripts its middlewares resolve to — the workspace detail's
// Info card and script cards, folded into this page.
export function usePipelineDefinition(
  jobName: string,
  pipeline: Connector | null | undefined,
) {
  const { data: workspaces } = useWorkspaces();
  const { data: services } = useServices();
  const workspace = useMemo(
    () => workspaceForJob(workspaces, jobName),
    [workspaces, jobName],
  );
  const serviceNames = useMemo(
    () => (services ? new Set(services.map((s) => s.name)) : null),
    [services],
  );
  const scripts = usePipelineScripts(pipeline ?? null, serviceNames);
  return { workspace, scripts };
}
